// BusinessCTASection.jsx
import React from "react";
import styles from "./BusinessCTASection.module.css";
import img from "../../../Images/voiceaiagents_img.png";
const PhoneIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92V21a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3 5.18 2 2 0 0 1 5 3h4.09a2 2 0 0 1 2 1.72l.57 4.01a2 2 0 0 1-.45 1.61L9.91 12a16 16 0 0 0 6.09 6.09l1.66-1.3a2 2 0 0 1 1.61-.45l4.01.57a2 2 0 0 1 1.72 2z" />
    </svg>
);

export default function BusinessCTASection() {
    return (
        <section className={styles.wrapper}>
            {/* Top Image */}
            <div className={styles.imageWrapper}>
                <img src={img} alt="Voice AI Agents" />
            </div>

            {/* CTA Card */}
            <div className={styles.ctaCard}>
                <h2>Ready to transform your business?</h2>
                <p className={styles.sub}>Still have Questions?</p>

                <div className={styles.actions}>
                    <button className={styles.primaryBtn}>
                        <PhoneIcon /> Schedule a demo
                    </button>
                    <button className={styles.secondaryBtn}> Get in touch with our team</button>
                </div>
            </div>
        </section>
    );
}
